import { designService } from '@paragon/data-connections';
import { getLoggedInUserOrganization } from '@paragon/login-tools';

import { materialSetPrototypeLoaded } from '../store/materialSetPrototypeSlice';
import { AsyncThunkActionVoid } from './thunkActionTypes';

export const loadMaterialSetPrototype = (): AsyncThunkActionVoid => async (dispatch, getState) => {
  const organization = getLoggedInUserOrganization(getState());
  if (organization == null) throw new Error('Unable to load material list—user is not logged in.');

  const organizationMaterialSet = await designService.materialLists.getOrganizationMaterialSetPrototype(organization);

  dispatch(materialSetPrototypeLoaded(organizationMaterialSet));
};
